export default (function () {
  return {
    rootStyle: {
      flexDirection: 'row',
      flexGrow: 0,
      flexShrink: 0
    },
    chevronWrapperStyle: {
      marginRight: -7,
      paddingTop: 3
    }
  };
});
//# sourceMappingURL=getDefaultStylesheet.js.map